// extracted by mini-css-extract-plugin
export var project_container = "portfolio-module--project_container--2JG68";
export var project_wrapper = "portfolio-module--project_wrapper--OmbD8";